import axios from '@/server/axios'

export function queryOnline() {
  return axios({
    url: 'officialWebsite/queryOnline.do',
    method: 'get',
    params: {

    }
  })
}